import EffortTag from "@/pages/explorer/components/effortTag/EffortTag";
import { InfoRow } from "./InfoRow";
import { Stack } from "@altimateai/lego";
import { getEffortLabel } from "@/pages/explorer/utils";
import { GetOpportunitiesDataResponse } from "@/pages/explorer/types";

const EffortInfo = ({ opportunity }: { opportunity: GetOpportunitiesDataResponse }) => {
  return (
    <InfoRow
      label="Effort"
      value={<EffortTag effort={getEffortLabel(opportunity.effort)} />}
      tooltip={
        <Stack tag="ul" direction="column">
          {opportunity.effort === 1 ? (
            <Stack tag="li" align="center">
              <EffortTag effort="low" /> Expected effort to implement this opportunity is low (&lt;
              3 hours)
            </Stack>
          ) : null}
          {opportunity.effort === 2 ? (
            <Stack tag="li" align="center">
              <EffortTag effort="medium" /> Expected effort to implement this opportunity is medium
              (3 - 8 hours)
            </Stack>
          ) : null}
          {opportunity.effort === 3 ? (
            <Stack tag="li" align="center">
              <EffortTag effort="high" /> Expected effort to implement this opportunity is high
              (&gt; 8 hours)
            </Stack>
          ) : null}
        </Stack>
      }
    />
  );
};

export default EffortInfo;
